import request from "@/utils/request";
const baseUrl = `${process.env.VUE_APP_AGENT_COMMON_SERVICE}/api/v1/dropdown`;
export default {
  getparameterdropdowns(code, userType) {
    return request({
      url: `${baseUrl}/get-parameter-data`,
      method: "GET",
      params: {
        parameter_code: code,
        user_type: userType,
      },
    });
  },

  //-----------------------------ADD CUSTOMERS-------------------------------//

  getCountryBirthList() {
    return request({
      url: `${baseUrl}/all-countries`,
      method: "get",
    });
  },
  getStatesList(country_code) {
    return request({
      url: `${baseUrl}/get-all-states?country_code=${country_code}`,
      method: "get",
    });
  },
  getCitiesList(country_code, state_code) {
    return request({
      url: `${baseUrl}/get-all-cities?country_code=${country_code}&state_code=${state_code}`,
      method: "get",
    });
  },
  getZipCodes() {
    return request({
      url: `${baseUrl}/all-zipcode`,
      method: "get",
    });
  },
  //----------------------calculator------------------------------------------------------//
  getgraphData(params) {
    return request({
      url: `${baseUrl}/get-graph-data`,
      method: "get",
      params: params,
    });
  },
  getBeneCountryList() {
    return request({
      url: `${baseUrl}/all-payout-countries`,
      method: "get",
    });
  },
  getpaymentModeByCntry(params) {
    return request({
      url: `${baseUrl}/payment-mode`,
      method: "get",
      params: params,
    });
  },
  getbankList(params) {
    return request({
      url: `${baseUrl}/get-bank-list`,
      method: "get",
      params: params,
    });
  },
  //------------------send Money-------------------------------------------------//
  getFxRates(params) {
    return request({
      url: `${baseUrl}/get-fx-rates`,
      method: "GET",
      params: params,
    });
  },
  getExchangeRates(data) {
    return request({
      url: `${baseUrl}/get-ex-rates`,
      method: "POST",
      data,
    });
  },
  getDepositChannel() {
    return request({
      url: `${baseUrl}/get-deposit-channel`,
      method: "GET",
    });
  },
};
